import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RdSAPLookupCodeDtoV0 } from 'src/rdsap-api';
import { AGGREGATED_DATA_SERVICE_TOKEN, IAggregatedDataService } from '../../models/data/aggregated-data.interface';


@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  rdSAPLookUpCodes$: Observable<RdSAPLookupCodeDtoV0[]>;
  eeRRLookupCodes: any;

  constructor(@Inject(AGGREGATED_DATA_SERVICE_TOKEN) private aggregatedDataService: IAggregatedDataService,) {
    this.rdSAPLookUpCodes$ = this.aggregatedDataService.rdSAPLookUpCodes$;
    this.aggregatedDataService.loadRdSAPLookUpCodes();
    this.rdSAPLookUpCodes$ = this.aggregatedDataService.rdSAPLookUpCodes$;
    this.rdSAPLookUpCodes$.subscribe(data => {
      if (data.length) {
        this.eeRRLookupCodes = data[0];
      }
    });
  }

  filterLookupCodes(filter) {
    return this.eeRRLookupCodes.lookupCodes.filter(x => x.dataItem === filter);
  }
}
